import * as React from 'react'

import Highlighter from '../../../components/highlighter'

import * as styles from './features.module.css'

interface IProps {
  term: string
  keyFeatures: string[]
}

const Features = ({ term, keyFeatures = [] }: IProps) => {
  if (!keyFeatures || !keyFeatures.length) {
    return null
  }

  return (
    <ul className={styles.root}>
      {keyFeatures.map(
        (feature: string, index: number): any => (
          <li className={styles.feature} key={index}>
            <Highlighter bold keywords={term.split(' ')}>
              {feature}
            </Highlighter>
          </li>
        )
      )}
    </ul>
  )
}

export default Features
